<script lang="ts">
  import { Label, Input, Tabs, TabItem } from "flowbite-svelte";
  import TipTapEditor from "$lib/admin/components/content/TipTapEditor/TipTapEditor.svelte";
  import type { IntroProps } from "@/src/types/components/Intro";

  export let props: IntroProps;
</script>

<div class="space-y-6 p-4 bg-white rounded-lg shadow">
  <div>
    <Label for="header" class="mb-2 text-lg font-medium">Heading</Label>
    <Input id="header" bind:value={props.header} placeholder="Write an H1" on:keyup size="lg" class="w-full" />
  </div>

  <Tabs style="underline" class="mt-6">
    <TabItem open title="Introduction">
      <div class="p-4">
        <TipTapEditor placeholder="Introduction" bind:text={props.content} on:keyup />
      </div>
    </TabItem>
  </Tabs>
</div>
